module.exports = __webpack_public_path__ + "media/application/images/27001-1ef6f40a846ff9f92578eecd8ce87404.jpg";